import React, { useState } from "react";

import Earnings from "./Earnings";
import Lists from "./Lists";
const Activity = () => {
  const [active, setActive] = useState<string>("earnings");

  return (
    <div className="w-full p-4   h-full">
      <h4 className="text-gray-900 tracking-wider dark:text-gray-100 font-sora text-[16px] font-bold ">
        Activities
      </h4>
      <div className="flex justify-start mt-4 gap-2 items-center">
        <button
          onClick={() => setActive("earnings")}
          className={` text-[11px] text-gray-900 dark:text-white p-3 rounded-xl font-semibold ${
            active === "earnings" ? "bg-gray-200 dark:bg-gray-700" : ""
          }`}
        >
          Earnings
        </button>
        <button
          onClick={() => setActive("list")}
          className={`text-[11px] text-gray-900 dark:text-white p-3 rounded-xl font-semibold ${
            active === "list" ? "bg-gray-200 dark:bg-gray-700" : ""
          }`}
        >
          Lists
        </button>
      </div>
      {active === "earnings" ? (
        <Earnings />
      ) : active === "list" ? (
        <Lists />
      ) : null}
    </div>
  );
};

export default Activity;
